<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetProducts" });
import { Heading } from "../../../../../typography/index.js";
import { InputToggle } from "../../../../../selects/index.js";
import { Textarea } from "../../../../../inputs/index.js";
import { BrandSelectMultiple, BrandSimilarTags } from "../../../../brand/index.js";
import { SelectCategories } from "../../../../category/index.js";
export let subscription;
let maxCategoryItems = void 0;
let categoryHint = void 0;
const ALLOWS_SIMILAR_BRANDS = subscription.constraints?.allowsSimilarBrands ?? false;
let isSimilarBrandsChecked = ALLOWS_SIMILAR_BRANDS;
const onBrandSelectionChange = (brandkeys) => {
    if (brandkeys !== void 0 && brandkeys.length > 1) {
        maxCategoryItems = 1;
        categoryHint = "For multiple brands, you can only select one category.";
        return;
    }
    maxCategoryItems = void 0;
    categoryHint = void 0;
};
$: onBrandSelectionChange(subscription.constraints?.brandKeys);
$: subscription.constraints.allowsSimilarBrands = isSimilarBrandsChecked;
$: if (subscription.constraints?.brandKeys?.length === 0) {
    isSimilarBrandsChecked = false;
    subscription.constraints.allowsSimilarBrands = false;
}
</script>

{#if subscription.constraints !== undefined}
    <div class = 's8-step-container'>
        <Heading size='xs'>Which categories, brands and products?</Heading>

        <div class = 's8-step-fieldset'>
            <div>
                <SelectCategories
                    bind:keys = { subscription.constraints.categoryKeys }
                    verticalCode = { subscription.constraints.verticalCode }
                    placeholder = 'Apparel, Footwear, Accessories, etc.'
                    name = 'subscription.categories'
                    maxItems = { maxCategoryItems }
                    hint = { categoryHint }
                    minItems = { 1 }
                />
                {#key subscription.constraints.brandKeys?.length}
                    <BrandSelectMultiple
                        bind:keys = { subscription.constraints.brandKeys }
                        verticalCode = { subscription.constraints.verticalCode }
                        placeholder = 'Adidas, Nike, Hoka, etc.'
                    />
                {/key}
                <BrandSimilarTags
                    bind:keys = { subscription.constraints.brandKeys }
                    parameters = {{ similarToBrandKeys: subscription.constraints.brandKeys }}
                />
                {#if subscription.constraints.brandKeys && subscription.constraints.brandKeys.length > 0}
                    <InputToggle
                        bind:isChecked={ isSimilarBrandsChecked }
                        name = 'subscription.similarBrands'
                        label = 'Notify me with deals that include brands similar to my selection.'
                    />
                {/if}
            </div>
            <Textarea
                bind:value = { subscription.products }
                maxLength = { 1000 }
                isRequired = { false }
                placeholder = 'Samba, Gazelle, Cloud 6, etc.'
                name = 'subscription.products'
                label = 'Any specific products or sub-categories?'
            />
        </div>
    </div>
{/if}

<style>
    div.s8-step-container {
        margin-bottom: 15px;
    }

    div.s8-step-fieldset {
        display: grid;
        -moz-column-gap: 100px;
             column-gap: 100px;
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 780px) {
        div.s8-step-fieldset {
            display: flex;
            flex-direction: column;
        }
    }</style>